import React from 'react';
import { Skeleton } from 'primereact/skeleton';
import '../ContractExpirationsSection/ContractExpirationsSection.styles.scss';
import './SectionSkeletons.styles.scss';

const ContentSectionSkeleton: React.FC = () => {
  return (
    <div className="section-content-skeleton">
      <Skeleton width="100%" height="25rem" borderRadius="0.75rem" />
    </div>
  );
};

export default ContentSectionSkeleton;
